/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import { BaseApiClient, RequestContext, ApiConfigManager, HttpRequestState } from '@sg/api/base-api-lib';
import { ClientIntegrationApiConfig } from '../api-config';

import { ClientIntegrationApi } from '../models';

@Injectable()
export class ClientIntegrationApiClient extends BaseApiClient<ClientIntegrationApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.clientIntegrationApiConfig);
  }

  clientIntegrationControllerSearchIntegrations(
    params: { body: ClientIntegrationApi.SearchClientIntegrationRequest; xSgUser?: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<Array<ClientIntegrationApi.ClientIntegrationDto>>;
  clientIntegrationControllerSearchIntegrations(
    params: { body: ClientIntegrationApi.SearchClientIntegrationRequest; xSgUser?: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<Array<ClientIntegrationApi.ClientIntegrationDto>>>;
  clientIntegrationControllerSearchIntegrations(
    params: { body: ClientIntegrationApi.SearchClientIntegrationRequest; xSgUser?: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<Array<ClientIntegrationApi.ClientIntegrationDto>>;
  clientIntegrationControllerSearchIntegrations(
    params: { body: ClientIntegrationApi.SearchClientIntegrationRequest; xSgUser?: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<Array<ClientIntegrationApi.ClientIntegrationDto>>>;
  clientIntegrationControllerSearchIntegrations(
    params: { body: ClientIntegrationApi.SearchClientIntegrationRequest; xSgUser?: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<Array<ClientIntegrationApi.ClientIntegrationDto>>>;
  clientIntegrationControllerSearchIntegrations(
    params: { body: ClientIntegrationApi.SearchClientIntegrationRequest; xSgUser?: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<Array<ClientIntegrationApi.ClientIntegrationDto>>>;
  clientIntegrationControllerSearchIntegrations(
    params: { body: ClientIntegrationApi.SearchClientIntegrationRequest; xSgUser?: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<Array<ClientIntegrationApi.ClientIntegrationDto>>(
      `${this.basePath}/gateway/admin/client-integrations/search`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  clientIntegrationControllerBlockChange(
    params: { body: ClientIntegrationApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<Array<ClientIntegrationApi.ClientIntegrationDto>>;
  clientIntegrationControllerBlockChange(
    params: { body: ClientIntegrationApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<Array<ClientIntegrationApi.ClientIntegrationDto>>>;
  clientIntegrationControllerBlockChange(
    params: { body: ClientIntegrationApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<Array<ClientIntegrationApi.ClientIntegrationDto>>;
  clientIntegrationControllerBlockChange(
    params: { body: ClientIntegrationApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<Array<ClientIntegrationApi.ClientIntegrationDto>>>;
  clientIntegrationControllerBlockChange(
    params: { body: ClientIntegrationApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<Array<ClientIntegrationApi.ClientIntegrationDto>>>;
  clientIntegrationControllerBlockChange(
    params: { body: ClientIntegrationApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<Array<ClientIntegrationApi.ClientIntegrationDto>>>;
  clientIntegrationControllerBlockChange(
    params: { body: ClientIntegrationApi.BlockChangeRequest; xSgUser?: string; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<Array<ClientIntegrationApi.ClientIntegrationDto>>(
      `${this.basePath}/gateway/admin/client-integrations/${this.encodeURI(String(params.id))}/block-change`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
